import { useTranslation } from 'react-i18next'
import { Badge, type BadgeProps } from '@ludus/ui'
import type { AuditState } from '../types.ts'

const TONES: Record<AuditState, NonNullable<BadgeProps['tone']>> = {
  draft: 'muted',
  snapshotting: 'info',
  processing: 'primary',
  paused_quota: 'warning',
  ready: 'success',
  failed: 'danger',
  archived: 'default',
  deleted: 'muted',
}

/** Every audit state has a badge and a label (§10.1). */
export function AuditStateBadge({ state }: { state: AuditState }) {
  const { t } = useTranslation()
  return (
    <Badge tone={TONES[state]} size="sm">
      {t(`pages.audits.state.${state}`, { defaultValue: state })}
    </Badge>
  )
}
